import React from 'react';
import CalendarTodayOutlined from '@mui/icons-material/CalendarTodayOutlined';
import ThemableButton, {
  ThemableButtonProps,
} from '../../../../theme/components/Button/ThemableButton';
import { useI18n } from '../../../../lib/hook/useI18n';

type Props = Pick<
  ThemableButtonProps,
  'disabled' | 'fullWidth' | 'onClick' | 'size'
>;

const ScheduleCallButton: React.FC<Props> = (props: Props) => {
  const { t } = useI18n();
  return (
    <ThemableButton
      {...props}
      startIcon={<CalendarTodayOutlined fontSize="small" />}
      styles={{ textTransform: 'none' }}
      dataTestId="button-schedule-call"
    >
      {t('schedule.button')}
    </ThemableButton>
  );
};

export default ScheduleCallButton;
